import Vue from 'vue';
import Checkbox from './Checkbox.vue';
import ServicesSelector from './ServicesSelector.vue';

Vue.component('e-checkbox', Checkbox);
Vue.component('services-selector', ServicesSelector);
